import * as React from 'react';
import { useStyles, useFormControlContext } from '@sravni/react-utils';
import modules_3ebc0b30 from '../styles/FormControl.module.less.js';

/**
 * @description Skeleton Avatar component.
 *
 * @component
 * @example
 * ```jsx
 * <Skeleton.Avatar />
 * ```
 */
const HelperText = (props) => {
    const { className, children, ...restProps } = props;
    const cx = useStyles(modules_3ebc0b30);
    const formControlContext = useFormControlContext();
    const classNames = cx(className, 'helper-text', {
        invalid: formControlContext.invalid,
        disabled: formControlContext.disabled,
    });
    return (React.createElement("div", { className: classNames, ...restProps }, children));
};
HelperText.displayName = 'HelperText';

export { HelperText as default };
//# sourceMappingURL=HelperText.js.map
